import React from "react";
import Column from "./column";
const Columns = (props) => {
    if (!props.innerBlocks || !props.innerBlocks.length) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: props.attributes.className }, props.innerBlocks.map((e, i) => {
        return React.createElement(Column, { ...e, key: i });
    })));
};
export default Columns;
